import { createContext } from 'react';
import type { Dispatch } from 'react';

import { initialAction, initialState } from './initial';

const ShippingConfigValueContext =
  createContext<typeof initialState>(initialState);

const ShippingConfigActionContext = createContext<
  Dispatch<typeof initialAction>
>(() => {});

export { ShippingConfigActionContext, ShippingConfigValueContext };
